import { render, staticRenderFns } from "./DarkContactUs.vue?vue&type=template&id=fb9fb194&"
import script from "./DarkContactUs.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DarkContactUs.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports